import React, { useState } from 'react';
import { QuoteSummary } from '../QuoteForms';
import { OrderProgress } from './OrderProgress';
import { OrderHeader, OrderDetails } from './OrderSummary';
import { OrderDocuments, OrderFulfillment } from './OrderActions';

export const OrderItem = ({ order, user, reload }) => {
  const [open, setOpen] = useState(false);
  return <article className="request-item" data-testid={`order-record-${order.id}`}>
    <OrderHeader order={order} user={user} open={open} toggle={() => setOpen(current => !current)} />
    {open && <div className="request-expanded">
      <OrderProgress order={order} />
      <OrderDetails order={order} />
      <QuoteSummary quote={order.quote} id={`order-${order.id}`} />
      <OrderDocuments order={order} user={user} />
      <OrderFulfillment order={order} user={user} reload={reload} />
    </div>}
  </article>;
};